'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Option {
  id: string;
  label: string;
  value: number;
  description?: string;
}

interface QuestionCardProps {
  question: string;
  description?: string;
  options: Option[];
  selectedValue: string;
  onSelect: (optionId: string) => void;
  questionNumber: number;
}

const QuestionCard = ({
  question,
  description,
  options,
  selectedValue,
  onSelect,
  questionNumber
}: QuestionCardProps) => {
  return (
    <div className="bg-card rounded-lg p-8 shadow-subtle border border-border">
      <div className="mb-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="text-lg font-display font-semibold text-primary">{questionNumber}</span>
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-display font-semibold text-secondary mb-2">{question}</h3>
            {description && (
              <p className="text-sm text-muted-foreground">{description}</p>
            )}
          </div>
        </div>
      </div>

      <div className="space-y-3">
        {options.map((option) => {
          const isSelected = selectedValue === option.id;
          return (
            <button
              key={option.id}
              onClick={() => onSelect(option.id)}
              className={`w-full text-left p-4 rounded-lg border-2 transition-all duration-300 ${
                isSelected
                  ? 'border-primary bg-primary/5 shadow-md'
                  : 'border-border hover:border-primary/50 hover:bg-muted/50'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
                  isSelected
                    ? 'border-primary bg-primary' :'border-border'
                }`}>
                  {isSelected && (
                    <Icon name="CheckIcon" size={16} className="text-white" />
                  )}
                </div>
                <div className="flex-1">
                  <p className={`font-medium mb-1 ${isSelected ? 'text-primary' : 'text-foreground'}`}>
                    {option.label}
                  </p>
                  {option.description && (
                    <p className="text-sm text-muted-foreground">{option.description}</p>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;